module.exports = __webpack_public_path__ + "static/media/back.3c4393a7.svg";